import React from "react";
import { Box } from "@mui/material";

interface ContentContainerProps {
  children: React.ReactNode;
}

export const ContentContainer: React.FC<ContentContainerProps> = ({ children }) => {
  return (
    <Box
      height="100svh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: "#fafafa" }}
    >
      <Box
        bgcolor="#ffffff"
        p={{ xs: 3, sm: 4 }}
        borderRadius="12px"
        boxShadow="0px 2px 8px rgba(0, 0, 0, 0.08)"
        width={{ xs: "95%", sm: "90%", md: "70%", lg: "50%" }}
        maxWidth="600px"
        sx={{
          boxSizing: "border-box",
          overflowY: "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
